import React from 'react';
import IcoInfo from '../IcoInfo/IcoInfo';
import styles from './InfoMsg.module.scss';

interface InfoMsg {
  msg: string;
  action?: string;
  efa?: boolean;
  color?: string;
  customClass?: string;
}

const InfoMsg: React.FC<InfoMsg>  = (props) => {
  const { msg, action = 'info', efa = false, color = '', customClass = '' } = props;

  const actionClass = styles[action] || '';
  const colorClass = styles[color] || '';
  const infoClass = efa ? styles.EfaClass : styles.InfoMsg;

  return (
    <div className={`${infoClass} ${actionClass} ${colorClass} ${customClass}`}>
      <div className={styles.IcoInfo}><IcoInfo ico={action} /></div>
      <span>{msg}</span>
    </div>
  );
};

export default React.memo(InfoMsg, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));
